enum BusinessTypeEnum {
  OFFICE = 'office',
  RETAIL = 'retail',
  GASTRO = 'gastro',
  MEDICINE = 'medicine',
  MISCELLANEOUS = 'miscellaneous',
}

export default BusinessTypeEnum;
